module.exports = __webpack_public_path__ + "static/media/tc.6847987d.svg";